import { motion } from "framer-motion";
import { Utensils, Stethoscope, Wrench, Scale, Scissors, Car, Store, HeartPulse } from "lucide-react";

const industries = [
  { icon: Utensils, label: "Restaurants" },
  { icon: Stethoscope, label: "Dental & Medical" },
  { icon: Wrench, label: "HVAC & Contractors" },
  { icon: Scale, label: "Law Firms" },
  { icon: Scissors, label: "Salons & Spas" },
  { icon: Car, label: "Auto Services" },
  { icon: Store, label: "Retail" },
  { icon: HeartPulse, label: "Clinics" },
];

export default function LogoMarquee() {
  const items = [...industries, ...industries];
  return (
    <section aria-label="Industries served" className="relative py-12 overflow-hidden border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col items-center gap-6">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-semibold"
        >
          Trusted across industries
        </motion.div>

        <div className="relative w-full">
          {/* fade masks */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#0A0F1C] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#0A0F1C] to-transparent" />

          <div className="overflow-hidden">
            <div className="flex marquee-track gap-10 min-w-max">
              {items.map((it, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2.5 text-white/50 hover:text-white transition-colors group"
                >
                  <span className="w-9 h-9 grid place-items-center rounded-full border border-white/10 bg-white/[0.02] group-hover:border-[#10B981]/40 group-hover:bg-[#10B981]/5 transition-colors">
                    <it.icon className="w-4 h-4" />
                  </span>
                  <span className="font-display text-sm font-semibold whitespace-nowrap">
                    {it.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
